'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIcon = undefined;
exports.default = Close;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Close(props) {
  var onClick = props.onClick,
      closeLabel = props.closeLabel,
      className = props.className,
      children = props.children;
  return _react2.default.createElement('button', {
    type: 'button',
    onClick: onClick,
    'aria-label': props['aria-label'] || closeLabel,
    className: (0, _classnames2.default)('rrui__button-reset', 'rrui__outline', 'rrui__close', className)
  }, children);
}

var CloseIcon = exports.CloseIcon = function CloseIcon() {
  return _react2.default.createElement('svg', {
    viewBox: '0 0 22 21',
    className: 'rrui__close__icon'
  }, _react2.default.createElement('g', {
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd',
    strokeLinecap: 'round'
  }, _react2.default.createElement('g', {
    className: 'rrui__close__icon-path',
    transform: 'translate(-1367.000000, -40.000000)',
    strokeWidth: '1'
  }, _react2.default.createElement('g', {
    transform: 'translate(1368.000000, 41.000000)'
  }, _react2.default.createElement('path', {
    d: 'M0.807611845,0.307611845 L19.1923882,18.6923882'
  }), _react2.default.createElement('path', {
    d: 'M0.807611845,0.307611845 L19.1923882,18.6923882',
    transform: 'translate(10.000000, 9.500000) scale(-1, 1) translate(-10.000000, -9.500000) '
  })))));
};

Close.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  closeLabel: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired
};
Close.defaultProps = {
  closeLabel: 'Close'
};